/**
 * @generated SignedSource<<a3cba9d4ffd99b2a46db85d51cba1df8>>
 * @relayHash ee6dc08c50d2bbc1ac1df2eb06da9fbb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4519dc477c1360c97963590817fcb4756237397400e0f86eb53e4b08bcb59cd9

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConvoAiJiraSimilarWorkItemsInput = {
  description?: string | null | undefined;
  excludeWorkItemIds?: ReadonlyArray<string> | null | undefined;
  projectId: string;
  similarityConfig?: ConvoAiJiraSimilarWorkItemsSimilarityConfig | null | undefined;
  summary: string;
  workItemId?: string | null | undefined;
};
export type ConvoAiJiraSimilarWorkItemsSimilarityConfig = {
  minimumSimScore?: number | null | undefined;
};
export type issueCreateSimilarWorkItemsQuery$variables = {
  cloudId: string;
  experience: string;
  workItemInput: ConvoAiJiraSimilarWorkItemsInput;
};
export type issueCreateSimilarWorkItemsQuery$data = {
  readonly convoai_jiraSimilarWorkItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly workItem: {
          readonly issueId: string;
          readonly issueTypeAvatarUrl: AGG$URL | null | undefined;
          readonly key: string;
          readonly summary: string | null | undefined;
          readonly webUrl: AGG$URL | null | undefined;
        } | null | undefined;
      } | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type issueCreateSimilarWorkItemsQuery = {
  response: issueCreateSimilarWorkItemsQuery$data;
  variables: issueCreateSimilarWorkItemsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "experience"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workItemInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "experience",
    "variableName": "experience"
  },
  {
    "kind": "Variable",
    "name": "workItemInput",
    "variableName": "workItemInput"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v4 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v5 = {
  "kind": "ScalarField",
  "name": "summary"
},
v6 = {
  "kind": "ScalarField",
  "name": "key"
},
v7 = {
  "kind": "ScalarField",
  "name": "issueTypeAvatarUrl"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "issueCreateSimilarWorkItemsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConvoAiJiraSimilarWorkItemsConnection",
        "kind": "LinkedField",
        "name": "convoai_jiraSimilarWorkItems",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConvoAiJiraSimilarWorkItemsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "ConvoAiJiraSimilarWorkItemSuggestion",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "workItem",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "issueCreateSimilarWorkItemsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConvoAiJiraSimilarWorkItemsConnection",
        "kind": "LinkedField",
        "name": "convoai_jiraSimilarWorkItems",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConvoAiJiraSimilarWorkItemsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "ConvoAiJiraSimilarWorkItemSuggestion",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "workItem",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4519dc477c1360c97963590817fcb4756237397400e0f86eb53e4b08bcb59cd9",
    "metadata": {},
    "name": "issueCreateSimilarWorkItemsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0597bf8fdf65717266ba5f803f23f7b1";

export default node;
